import React from "react";

export const LeaveIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        stroke="#113357"
        strokeLinecap="round"
        strokeWidth="1.2"
        d="M12.5 7V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h4.5a2 2 0 0 0 2-2v-1.5"
      ></path>
      <path
        stroke="#113357"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M10 10h7M15 12l2-2M15 8l2 2"
      ></path>
    </svg>
  );
};
